import { createContext, useState } from "react";
import "../App.css"

// import  useLocalStorage  from "./useLocalStorage";

export const BackendDataContext = createContext();

export const BackendDataProvider = ({ children }) => {
  // State to hold the Backend data

  const [chats, setChats] = useState([]);

  

  // Compile dataObject from state
  const dataObject = {
    chats, setChats,
  };



  return (
    <BackendDataContext.Provider value={dataObject}>
      {children}
    </BackendDataContext.Provider>
  );
};
